<template>
  <v-card class="filter-panel">
    <h1 class="filter-title">Gestion de Entidades Comerciales</h1>
    <v-form ref="form" @submit.prevent="applyFilters" @keydown.enter.prevent="applyFilters">
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field label="Filtrar por Razon Social" v-model="filter.name"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Filtrar por CUIT" v-model="filter.cuit"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-select label="Filtrar por Tipo de Responsabilidad ante el IVA"
            v-model="filter.responsibleType"
            item-title="description"
            :items="responsibleType"/>
        </v-col>
      </v-row>
      <div class="filter-actions">
        <v-btn type="button" @click="clearFilters" color="secondary" variant="tonal">{{ CONST.CLEAN_FILTERS }}</v-btn>
        <v-btn type="submit" color="primary">{{ CONST.APPLY_FILTERS }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterCompanyForm',

  data: () => ({
    filter: {
      name: '',
      cuit: '',
      responsibleType: ''
    },
    responsibleType: []
  }),

  created () {
    this.CONST = CONST
    this.initialize()
  },

  computed: {
    ...mapGetters('companyModule', ['getCompanies'])
  },
  watch: {
    getCompanies: function () {
      this.$refs.form.reset()
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch('companyModule/getResposibleType')
        .then(() => {
          this.responsibleType = this.$store.getters['companyModule/getResposibleType']
        })
    },

    applyFilters () {
      this.$store.dispatch('companyModule/filterItems', this.filter)
    },

    clearFilters () {
      this.$store.dispatch('companyModule/refreshFilteredCompanies')
      this.$refs.form.reset()
    }
  }
}
</script>
